import { Modal, ModalOverlay, ModalContent, ModalBody } from "@chakra-ui/react";
import {
  EmailVerifyWrapper,
  EmailVerifyIconCircle,
  EmailVerifyIcon,
  EmailVerifyHeading,
  EmailVerifyText,
  VerifyButton,
} from "../styles";

import { useTranslation } from "react-i18next";

const EmailVerificationModal = ({ isOpen, onClose, onVerify }: otpProps) => {
  const { t } = useTranslation("common");

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      isCentered
      closeOnEsc={false}
      closeOnOverlayClick={false}
    >
      <ModalOverlay />
      <ModalContent borderRadius="16px" maxW="420px" bg="#FFFFFF">
        <ModalBody>
          <EmailVerifyWrapper>
            <EmailVerifyIconCircle>
              <EmailVerifyIcon />
            </EmailVerifyIconCircle>

            <EmailVerifyHeading>
              {t("userProfile.emailverification")}
            </EmailVerifyHeading>

            <EmailVerifyText>
              {t("userProfile.emailverificationtext")}
            </EmailVerifyText>

            <VerifyButton onClick={onVerify}>
              {t("userProfile.verifyEmail")}
            </VerifyButton>
          </EmailVerifyWrapper>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default EmailVerificationModal;
